import { cn } from '../../lib/cn';
import styles from './Skeleton.module.css';

export type SkeletonVariant = 'text' | 'card' | 'row';

export type SkeletonProps = {
  readonly variant?: SkeletonVariant;
  readonly width?: string;
  readonly height?: string;
  readonly count?: number;
};

/** Скелетоны вместо спиннеров (docs/06 §5.5), структура как у контента. */
export function Skeleton({ variant = 'text', width, height, count = 1 }: SkeletonProps) {
  return (
    <div className={styles['group']} aria-hidden>
      {Array.from({ length: count }, (_, index) => (
        <span
          key={index}
          className={cn(styles['skeleton'], styles[variant])}
          style={{ width, height }}
        />
      ))}
    </div>
  );
}
